import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import { Box } from "@mui/material";
import React, { useCallback } from "react";
import styles from "../IsochroneDialog.module.scss";

export const ProfileButton = React.memo(
  (props: {
    walking: boolean;
    cycling: boolean;
    driving: boolean;

    onWalkingChange: (checked: boolean) => void;
    onCyclingChange: (checked: boolean) => void;
    onDrivingChange: (checked: boolean) => void;
  }) => {
    const onWalkingClick = useCallback(
      () => props.onWalkingChange(!props.walking),
      [props]
    );

    const onCyclingClick = useCallback(
      () => props.onCyclingChange(!props.cycling),
      [props]
    );

    const onDrivingClick = useCallback(
      () => props.onDrivingChange(!props.driving),
      [props]
    );

    return (
      <>
        <Box
          onClick={onWalkingClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.walking
          } ${props.walking ? styles.on : styles.off}`}
        >
          <DirectionsWalkIcon className={styles.walkingIcon} />
          徒歩
        </Box>
        <Box
          onClick={onCyclingClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.cycling
          } ${props.cycling ? styles.on : styles.off}`}
        >
          <DirectionsBikeIcon className={styles.cyclingIcon} />
          自転車
        </Box>
        <Box
          onClick={onDrivingClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.driving
          } ${props.driving ? styles.on : styles.off}`}
        >
          <DirectionsCarIcon className={styles.drivingIcon} />車
        </Box>
      </>
    );
  }
);
